export const termsMap: any = {
    eu: [
        {
            title: `<strong>Product Usage: </strong>`,
        },
        {
            title: '[1] Tested in a 10 cubic meter space at 77°F/25℃. Performance may vary with room size and temperature.',
        },
        {
            title: '[2] Tested in a 10 cubic meter space at 60°F/15℃. Results may differ depending on conditions.',
        },
        {
            title: '[3] 8 hours of wireless use in Eco Mode under optimal conditions. Battery life may vary based on usage and environment.',
        },
    ],
    uk: [
        {
            title: `<strong>Product Usage: </strong>`,
        },
        {
            title: '[1] Tested in a 10 cubic meter space at 77°F/25℃. Performance may vary with room size and temperature.',
        },
        {
            title: '[2] Tested in a 10 cubic meter space at 60°F/15℃. Results may differ depending on conditions.',
        },
        {
            title: '[3] 8 hours of wireless use in Eco Mode under optimal conditions. Battery life may vary based on usage and environment.',
        },
    ],
    de: [
        {
            title: `<strong>Produktverwendung: </strong>`,
        },
        {
            title: '[1] Getestet in einem 10 m³ Raum bei 25 °C. Die Leistung kann je nach Raumgröße und Temperatur variieren.',
        },
        {
            title: '[2] Getestet in einem 10 m³ Raum bei 15 °C. Ergebnisse können je nach Bedingungen abweichen.',
        },
        {
            title: '[3] 8 Stunden kabelloser Betrieb im Eco Modus unter optimalen Bedingungen. Die Batterielaufzeit kann je nach Nutzung und Umgebung variieren.',
        },
    ],
    fr: [
        {
            title: `<strong>Utilisation du produit : </strong>`,
        },
        {
            title: '[1] Testé dans un espace de 10 mètres cubes à 25 ℃. Les performances peuvent varier en fonction de la taille et de la température de la pièce.',
        },
        {
            title: '[2] Testé dans un espace de 10 mètres cubes à 15 ℃. Les résultats peuvent différer selon les conditions.',
        },
        {
            title: `[3] 8 heures d'utilisation sans fil en mode Eco dans des conditions optimales. La durée de vie de la batterie peut varier en fonction de son utilisation et des conditions environnementales.`,
        },
    ],
    it: [
        {
            title: `<strong>Utilizzo del prodotto: </strong>`,
        },
        {
            title: '[1] Test effettuati in uno spazio di 10 metri cubici a 25 °C. Le prestazioni possono variare in base alle dimensioni dell’ambiente e alla temperatura.',
        },
        {
            title: '[2] Test effettuati in uno spazio di 10 metri cubici a 15 °C. I risultati possono variare in funzione delle condizioni presenti.',
        },
        {
            title: '[3] 8 ore di utilizzo wireless nella modalità Eco in condizioni ottimali. La durata della batteria può variare in base all’utilizzo e alle condizioni ambientali.',
        },
    ],
    es: [
        {
            title: `<strong>Uso del producto: </strong>`,
        },
        {
            title: '[1] Probado en un espacio de 10 metros cúbicos a 25 ℃. El rendimiento puede variar según el tamaño y la temperatura de la habitación.',
        },
        {
            title: '[2] Probado en un espacio de 10 metros cúbicos a 15 ℃. Los resultados pueden variar dependiendo de las condiciones.',
        },
        {
            title: '[3] 8 horas de uso inalámbrico en modo Eco en condiciones óptimas. La duración de la batería puede variar según el uso y el entorno.',
        },
    ],
    us: [
        {
            title: `<strong>Product Usage: </strong>`,
        },
        {
            title: '[1] Tested in a 10 cubic meter space at 77°F. Performance may vary with room size and temperature.',
        },
        {
            title: '[2] Tested in a 10 cubic meter space at 60°F. Results may differ depending on conditions.',
        },
        {
            title: '[3] 8 hours of wireless use in Eco Mode under optimal conditions. Battery life may vary based on usage and environment. ',
        },
    ],
    ca: [
        {
            title: `<strong>Product Usage: </strong>`,
        },
        {
            title: '[1] Tested in a 10 cubic meter space at 25°C. Performance may vary with room size and temperature.',
        },
        {
            title: '[2] Tested in a 10 cubic meter space at 25°C. Results may differ depending on conditions.',
        },
        {
            title: '[3] 8 hours of wireless use in Eco Mode under optimal conditions. Battery life may vary based on usage and environment. ',
        },
    ],
    au: [
        {
            title: <strong>T&C: </strong>,
        },
        {
            title: 'All the test results displayed on the page are based on our internal testing, subject to different conditions, including temperature variations, humidity levels, and equipment calibration standards. Please note that these results are provided for informational purposes only and should not be considered as conclusive evidence for all scenarios. Data was tested in a controlled laboratory environment and actual user experience may vary.',
        },
        {
            title: '1. The runtime is based on laboratory tests conducted with common household appliances under normal room temperature conditions. The "double runtime" claim specifically refers to tests using a 3W light or Wi-Fi router.',
        },
        {
            title: '2. The noise level data is based on laboratory tests conducted at a room temperature of 89.6°F (32°C). Actual use may have slight deviations due to variations in the real environment.',
        },
        {
            title: '3. The input and output wattage of the Smart Extra Battery will decrease to 100W when ambient temperature is higher than 95°F (35°C).',
        },
        {
            title: '4. The IP54 water-resistance rating applies only to the battery pack, not the entire package. It does not prevent water immersion but can prevent fire or explosion in the event of a short circuit if the battery is splashed with water or rain, ensuring user safety and property protection',
        },
    ],
};
